/*
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2022-05-12 23:34:27
 * @LastEditTime: 2022-06-18 17:03:59
 * @Description: 固定路由列表
 * @
 * @Copyright (c) 2022 by yubaolee | ahfu~ , All Rights Reserved. 
*/
import Vue from 'vue'
import Router from 'vue-router'


// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout — 懒加载，登录页不需要加载这个大组件 */
const Layout = () => import(/* webpackChunkName: "chunk-layout" */ '../views/layout/Layout')

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/
export const constantRouterMap = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    meta: {
      sortNo: 0
    },
    hidden: true
  },
  {
    path: '/printData',
    component: () => import('@/views/dlsvprint/formdata'),
    meta: {
      sortNo: 0
    },
    hidden: true
  },
  {
    path: '/orginfo',
    component: () => import('@/views/orginfo/index'),
    meta: {
      sortNo: 0
    },
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    meta: {
      sortNo: 0
    },
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    meta: {
      sortNo: 0
    },
    hidden: true
  },
  {
    path: '/forms',
    component: Layout,
    redirect: 'noredirect',
    name: 'forms',
    meta: {
      title: '表单设计',
      icon: 'form'
    },
    children: [{
      path: 'add',
      component: () =>
                  import('@/views/forms/add'),
      name: 'formAdd',
      hidden: true,
      meta: {
        notauth: true,
        title: '添加表单',
        noCache: true,
        icon: 'star'
      }
    }, {
      path: 'edit/:id',
      component: () =>
                  import('@/views/forms/edit'),
      name: 'formEdit',
      hidden: true,
      meta: {
        notauth: true,
        title: '编辑表单',
        noCache: true,
        icon: 'list'
      }
    }]
  },
  //流程模版路由
  {
    path: '/flowschemes',
    component: Layout,
    redirect: 'noredirect',
    name: 'flowschemes',
    meta: {
      title: '流程设计',
      icon: 'eye'
    },
    children: [
      {
        path: 'add',
        component: () => import('@/views/flowschemes/add'),
        name: 'schemeAdd',
        hidden: true,
        meta: {
          notauth: true,
          title: '添加模板',
          noCache: true,
          icon: 'star'
        }
      },
      {
        path: 'edit/:id',
        component: () => import('@/views/flowschemes/edit'),
        name: 'schemeEdit',
        hidden: true,
        meta: {
          notauth: true,
          title: '编辑流程',
          noCache: true,
          icon: 'list'
        }
      }
    ]
  },
  // 流程实例路由
  {
    path: '/flowinstances',
    component: Layout,
    redirect: 'noredirect',
    name: 'flowinstances',
    meta: {
      title: '流程中心',
      icon: 'guide'
    },
    children: [{
        path: 'detail/:id',
        component: () =>
          import('@/views/flowinstances/detail'),
        name: 'flowinstanceDtl',
        hidden: true,
        meta: {
          notauth: true,
          title: '流程详情',
          noCache: true,
          icon: 'list'
        }
      },
      {
        path: 'verify/:id',
        component: () =>
          import('@/views/flowinstances/verify'),
        name: 'verifyFlowinstance',
        hidden: true,
        meta: {
          notauth: true,
          title: '处理流程',
          noCache: true,
          icon: 'list'
        }
      },

      {
        path: 'update/:id',
        component: () =>
          import('@/views/flowinstances/update'),
        name: 'updateFlowinstance',
        hidden: true,
        meta: {
          notauth: true,
          title: '编辑流程',
          noCache: true,
          icon: 'list'
        }
      },
      {
        path: 'add',
        component: () =>
          import('@/views/flowinstances/add'),
        name: 'instanceAdd',
        meta: {
          notauth: true,
          title: '发起流程',
          noCache: true,
          icon: 'star'
        }
      }
    ]
  },
  {
    path: '/oidc-callback', // Needs to match redirect_uri in you oidcSettings
    name: 'oidcCallback',
    component: () => import(/* webpackChunkName: "chunk-oidc" */ '@/views/OidcCallback'),
    meta: {
      sortNo: 0,
      isOidcCallback: true,
      isPublic: true
    }
  },
  {
    path: '/oidcRedirect', // oidc临时跳转页面
    name: 'oidcRedirect',
    meta: {
      sortNo: 0
    },
    component: () => import(/* webpackChunkName: "chunk-oidc" */ '@/views/OidcRedirect')
  },
  {
    path: '/',
    component: Layout,
    redirect: 'dashboard',
    name: 'layout',
    meta: {
      sortNo: 0
    },
    children: [{
      path: '/dashboard',
      name: 'dashboard',
      meta: {
        title: '主页',
        icon: 'iconfont icon-zhuyeicon',
        sortNo: 0
      },
      component: () => import('@/views/dashboard/index')
    },
    {
      path: '/profile',
      name: 'profile',
      hidden: true,
      meta: {
        title: '个人中心',
        icon: 'guide',
        sortNo: 0
      },
      component: () => import('@/views/usermanager/profile')
    },
     {
      // path: '/iframePage/:url/:name',
      path: '/iframePage/:code',
      name: 'iframePage',
      hidden: true,
      meta: {
        title: '接口文档',
        icon: 'guide',
        sortNo: 0
      },
      component: () => import('@/views/iframePage/index')
    },
    // {
    //   path: '/newprofile',
    //   name: 'newprofile',
    //   meta: { title: '个人中心', icon: 'guide', sortNo: 0 },
    //   component: () => import('@/views/usermanager/newprofile')
    // }
  ]
  },

  // {
  //   path: '/swagger',
  //   component: Layout,
  //   meta: { sortNo: 0 },
  //   children: [{
  //     path: '',
  //     name: 'swagger',
  //     meta: { title: '接口文档', icon: 'guide', sortNo: 0 },
  //     component: () => import('@/views/swagger/index')
  //   }]
  //}
]

var router = new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior(to,from,savePosition){
    if(savePosition){
      //解决页面从列表页跳转到详情页返回,初始在原来位置
      return savePosition
    }else{
      //解决页面跳转后页面高度和前一个页面高度一样
      return {x:0,y:0}
    }
  },

  routes: constantRouterMap
})

export default router